// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__ROzrX","header":"styles_header__J1-E8"};